import { Chip, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useRecordContext } from "react-admin";
import EnabledDisabledInput from "../unit/EnabledDisabledInput";

const ProductLine = (props: any) => {
  const product = props.product;
  const [pchecked, setPchecked] = React.useState(
    props.checked && product.iStatus
  );
  useEffect(() => {
    setPchecked(props.checked);
  }, [props.checked]);
  return (
    <>
      <Typography
        sx={{ color: product.iStatus ? "black" : "#ddd", mb: "10px" }}
      >
        <input
          type="checkbox"
          checked={pchecked}
          disabled={!product.iStatus}
          value={product.id}
          className="partners_select_product"
          onChange={(e) => {
            setPchecked(e.target.checked);
            // props?.cb(product.id, e.target.checked);
          }}
        />
        <Chip
          label={`#` + product.id}
          sx={{
            ml: "5px",
            mr: "5px",
            mt: "-5px",
            width: "70px",
            p: "0px",
            height: "24px",
            verticalAlign: "middle",
            fontSize: "14px",
            backgroundColor: product.iStatus ? "#e0e0e0" : "#f5f5f5",
            color: product.iStatus ? "black" : "gray",
          }}
        />
        {product.name}
      </Typography>
    </>
  );
};

const LinkToBankProducts = ({ ...props }) => {
  const record = useRecordContext();
  // const selectIdArray = record?.p_id_list; //checked product
  const selectIdArray = record?.productIds; //checked product
  const productList = props?.productList;

  return (
    <>
      <Typography
        variant="h3"
        sx={{ fontWeight: "bold", color: "grey", marginBottom: "15px" }}
      >
        {props?.title || `Select Products`}
      </Typography>
      {productList?.map((product: any) => (
        <li
          key={product.id}
          style={{
            listStyle: "none",
            color: product.iStatus == "1" ? "black" : "rgba(0, 0, 0, 0.26)",
          }}
        >
          <ProductLine
            product={product}
            checked={selectIdArray && selectIdArray?.includes(product.id)}
            // cb={changeSelectProducts}
          />
        </li>
      ))}
    </>
  );
};

export default LinkToBankProducts;
